/* eslint-disable max-len */
import React from 'react'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ErrorBoundary } from '../../../../../components/common/ErrorBoundary'
import { ViewBase } from '../../../../../components/common/ViewBase'
import { ManagementPartnerCard } from '../../../../../components/society/ManagementPartner/ManagementPartnerCard'
import { ManagementPartnerBase } from '../../../../../components/society/ManagementPartner/ManagementPartnerBase'
import { ManagementPartner } from '../../../../../components/society/ManagementPartner/management_partner'
import { BOSTADSRATTERNA_STATUTES_LINK } from '../../../../../constants/Links'
import { useCurrentSociety } from '../../../../../hooks/useCurrentSociety'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../../navigation/reverseDocumentTitle'
import { i18nSocietyType } from '../../../../../i18n'

export const BostadsratternaStatutesView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(
    reverseDocumentTitle('management:bostadsratterna-statutes', {
      '{{ societyName }}': society?.name,
    })
  )

  return (
    <ErrorBoundary>
      <ViewBase
        title={translate('bostadsratterna.bostadsratternaStatutesView.title')}
      >
        <ManagementPartnerBase partner={ManagementPartner.BOSTADSRATTERNA}>
          <ManagementPartnerCard
            url={BOSTADSRATTERNA_STATUTES_LINK}
            title={translate(
              'bostadsratterna.bostadsratternaStatutesView.statutesTitle'
            )}
            text={translate(
              'bostadsratterna.bostadsratternaStatutesView.statutesText',
              { context: i18nSocietyType(society?.societyTypeDisplayName) }
            )}
          />
        </ManagementPartnerBase>
      </ViewBase>
    </ErrorBoundary>
  )
}
